export const CallLayoutType = {
  Auto: 'auto',
  Grid: 'grid',
  Speaker: 'speaker',
  Sidebar: 'sidebar',
  Focus: 'focus',
} as const

export type CallLayoutType = (typeof CallLayoutType)[keyof typeof CallLayoutType]
